export default "__VITE_ASSET__B5$5WmJL__"